import { HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable()
export class RequestCacheService {
    private cache = new Map<string, HttpResponse<any>>()

    get(req: HttpRequest<any>): HttpResponse<any> | null {
        const url = req.urlWithParams
        const cached = this.cache.get(url)

        return cached ? cached : null
    }

    put(req: HttpRequest<any>, response: HttpResponse<any>): void {
        const url = req.urlWithParams
        this.cache.set(url, response)
    }
}
